"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LinearLoader", {
  enumerable: true,
  get: function () {
    return _LinearLoader.LinearLoader;
  }
});
var _LinearLoader = require("./LinearLoader");